import React from 'react';
import Sidebar from './Sidebar';
import { Toaster } from 'react-hot-toast';
import './layout.css';

export default function Layout({ children }) {
  return (
    <div className="app-layout">
      <Sidebar />
      <main className="app-main">
        <div className="app-content">
          {children}
        </div>
      </main>
      <Toaster position="top-right" toastOptions={{ style: { fontSize: '14px' } }} />
    </div>
  );
}
